import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { bind } from 'app/utils/decorators/decoratorUtils';
import Widget from 'app/components/atoms/Widget/Widget';
import { widgetTypes } from '../dashboardUtils';
import { getLastUsedProcesses } from 'store/actions/dashboard/dashboardActions';
import { showToastr } from 'store/actions/app/appActions';
import MyAppIcon from 'app/components/ABox/MyApps/MyAppIcon';
import history from 'store/History';

const AppsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: start;

    & div[class*="AvatarStyled"] {
        width: 48px !important;
        height: 48px !important;
    }
`;

/**
 * Widget for displaying recently used app
 */
class MyAppsWidget extends PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool,
        apps: PropTypes.array,
        getLastUsedProcesses: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.props.getLastUsedProcesses();
    }

    @bind
    handleMenuItemClick(menu) {
        const { getLastUsedProcesses, menuItemClick } = this.props;
        if (menu === 'Refresh') {
            getLastUsedProcesses();
        } else {
            menuItemClick && menuItemClick(menu);
        }
    }

    @bind
    buildAppsList(apps) {
        return apps.map((app) => (
            <MyAppIcon
                onClick={() => {
                    if (!app?.canView) {
                        this.props.showToastr({
                            severity: 'warning',
                            detail: 'You have no permission to see selected App.',
                        });
                    } else {
                        history.push(`/abox/process-start/${app.id}`);
                    }
                }}
                key={app.id}
                appName={app.name}
                iconName={app.iconName}
                iconColor={app.iconColor}
                iconType={app.iconType}
                flexGrow={'0 !important'}
            />
        ));
    }

    render() {
        const { isLoading, apps, item, permissions } = this.props;
        return (
            <Widget
                title={item?.widgetName || 'Apps'}
                subHeader='Recently Used Apps'
                content={!isLoading && !apps?.length ? 'No Results' : <AppsWrapper>{this.buildAppsList(apps)}</AppsWrapper>}
                url={'/abox/processes-new'}
                urlText='All Apps'
                loading={isLoading}
                menuItemClick={this.handleMenuItemClick}
                permissions={permissions}
                item={item}
                type={widgetTypes.userApps}
            />
        );
    }
}

const mapStateToProps = (state) => {
    let apps = state.dashboard?.lastUsedProcesses?.records || [];
    if (apps.length > 10) {
        apps = apps.slice(0, 10);
    }
    return {
        apps,
        isLoading: state.dashboard?.lastUsedProcesses?.isLoading,
    };
};

export default connect(mapStateToProps, { getLastUsedProcesses, showToastr })(MyAppsWidget);
